export default __webpack_public_path__ + "static/media/arrow-down.4e33fcd4.svg";